export declare namespace ControlObjectIdentifyTokenSections {
	interface ResultTitle {
		color: string;
		fontSize: string;
		lineHeight: string;
	}

	interface ResultSubtitle {
		color: string;
		fontSize: string;
	}

	interface UnlinkedBadge {
		background: string;
		borderRadius: string;
		iconColor: string;
		iconSize: string;
	}

	interface EmptyText {
		color: string;
		fontSize: string;
	}

	interface SubjectRow {
		borderColor: string;
		name: {
			color: string;
			fontSize: string;
			fontWeight: string;
		};
		address: {
			color: string;
			fontSize: string;
		};
	}

	interface LinkButton {
		color: string;
		fontSize: string;
	}
}

export type ControlObjectIdentifyTokens = {
	resultTitle: ControlObjectIdentifyTokenSections.ResultTitle;
	resultSubtitle: ControlObjectIdentifyTokenSections.ResultSubtitle;
	unlinkedBadge: ControlObjectIdentifyTokenSections.UnlinkedBadge;
	emptyText: ControlObjectIdentifyTokenSections.EmptyText;
	subjectRow: ControlObjectIdentifyTokenSections.SubjectRow;
	linkButton: ControlObjectIdentifyTokenSections.LinkButton;
};

export const resultTitle: ControlObjectIdentifyTokenSections.ResultTitle = {
	color: '{surface.800}',
	fontSize: '1rem',
	lineHeight: '1.625rem',
};

export const resultSubtitle: ControlObjectIdentifyTokenSections.ResultSubtitle = {
	color: '{surface.800}',
	fontSize: '0.875rem',
};

export const unlinkedBadge: ControlObjectIdentifyTokenSections.UnlinkedBadge = {
	background: '{yellow.50}',
	borderRadius: '2px',
	iconColor: '{orange.600}',
	iconSize: '0.875rem',
};

export const emptyText: ControlObjectIdentifyTokenSections.EmptyText = {
	color: '{surface.500}',
	fontSize: '0.875rem',
};

export const subjectRow: ControlObjectIdentifyTokenSections.SubjectRow = {
	borderColor: '{surface.100}',
	name: {
		color: '{text.color}',
		fontSize: '0.875rem',
		fontWeight: '500',
	},
	address: {
		color: '{text.muted.color}',
		fontSize: '0.875rem',
	},
};

export const linkButton: ControlObjectIdentifyTokenSections.LinkButton = {
	color: '{primary.color}',
	fontSize: '0.875rem',
};

export default {
	resultTitle,
	resultSubtitle,
	unlinkedBadge,
	emptyText,
	subjectRow,
	linkButton,
} satisfies ControlObjectIdentifyTokens;
